"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStringifiedFeatureSwitches = exports.useIdentifyUser = exports.useFeatureSwitchContext = exports.useIsInContext = exports.useFeatureSwitches = exports.useFeatureFlag = void 0;
var react_1 = require("react");
var context_1 = require("./context");
var useFeatureFlag = function (featureName) {
    var _a;
    var ctx = react_1.useContext(context_1.FeatureSwitchContext);
    if (!ctx)
        return false;
    return ((_a = ctx.featureSwitches) === null || _a === void 0 ? void 0 : _a[featureName]) || false;
};
exports.useFeatureFlag = useFeatureFlag;
var useFeatureSwitches = function () {
    var featureSwitches = react_1.useContext(context_1.FeatureSwitchContext).featureSwitches;
    return featureSwitches;
};
exports.useFeatureSwitches = useFeatureSwitches;
var useIsInContext = function () {
    var ctx = react_1.useContext(context_1.FeatureSwitchContext);
    return !!ctx;
};
exports.useIsInContext = useIsInContext;
var useFeatureSwitchContext = function () {
    return react_1.useContext(context_1.FeatureSwitchContext);
};
exports.useFeatureSwitchContext = useFeatureSwitchContext;
var useIdentifyUser = function () {
    var flagManager = react_1.useContext(context_1.FeatureSwitchContext).flagManager;
    return function (userId) { return flagManager.identifyUser(userId); };
};
exports.useIdentifyUser = useIdentifyUser;
var useStringifiedFeatureSwitches = function () {
    var featureSwitches = exports.useFeatureSwitches();
    return JSON.stringify(featureSwitches);
};
exports.useStringifiedFeatureSwitches = useStringifiedFeatureSwitches;
